export default __webpack_public_path__ + "static/media/atara-german.44a6b1b1.png";